import Link from "next/link";
import { HeroStar } from "../common/Icons";
import Image from "next/image";
import { useEffect, useState } from "react";

const words = ["Course", "University"];
const Hero = () => {
	const [index, setIndex] = useState<number>(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setIndex((prev) => (prev + 1) % words.length);
		}, 2000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div className="flex flex-col w-full">
			<Image
				className="w-full sm:hidden bg-white object-cover"
				width={450}
				height={371}
				sizes="(max-width: 640px) 100vw, 450px"
				src={"/assets/images/png/homepage/heroImageMobile.webp"}
				alt="India's Trusted Study Abroad Platform"
				priority
				fetchPriority="high"
			/>
			<div className="flex h-full flex-col justify-center items-start container max-w-[1400px] mx-auto pt-[24px] xxs:pt-[32px] sm:py-[80px] md:py-[100px] px-4 xxs:px-6 sm:px-[40px] relative z-0">
				<div className="flex items-center gap-[10px] rounded-full">
					<div className="m-[2px]">
						{/* <HeroStar /> */}
						<p className="font-semibold text-[10px] xxs:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl ff_poppins text-black sm:text-white relative tracking-wider uppercase">
							<span className="absolute h-[2px] sm:h-[3px] bg-white w-full -bottom-[3px] left-0 "></span>
							India’s Trusted Study Abroad Platform
						</p>
					</div>
				</div>
				<h1 className="mt-3 sm:text-white font-bold text-[28px] xxs:text-[32px] xs:text-[38px] sm:text-[40px] md:text-[48px] lg:text-[56px] xl:text-[64px] max-w-[800px] leading-[36px] xxs:leading-[42px] xs:leading-[50px] sm:leading-[52px] md:leading-normal">
					Find Your{" "}
					<span
						key={index}
						className="animate-word inline-block min-w-[120px] xxs:min-w-[140px] sm:min-w-[190px] md:min-w-[230px] lg:min-w-[270px] xl:min-w-[310px] text-left  sm:text-inherit">
						{words[index]}
					</span>{" "}
					<br className="lg:hidden" />
					Within{" "}
					<span className="relative inline-block">
						<Image
							src="/assets/images/png/heroHighlight.png"
							alt=""
							width={550}
							height={100}
							className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -z-10 max-w-none"
						/>
						<span className="ff_poppins relative z-10 text-[#1776F0]">
							60 Seconds.
						</span>
					</span>
				</h1>
				<Link
					href={"/tools/course-finder?step=qualification"}
					className="w-full sm:w-auto py-3.5 md:py-4 px-[40px] xxs:px-[48px] rounded-full mt-[24px] xxs:mt-[32px] sm:mt-5 bg-primary-gradient font-medium text-white text-center text-sm xxs:text-base sm:text-xl lg:text-2xl ff_poppins inline-flex sm:inline-flex justify-center items-center overflow-hidden transition relative hover:scale-[1.05] focus:scale-[1.05] duration-300 ease-in-out">
					<span className="relative z-20 inline-flex items-center gap-2">
						<Image
							src="/assets/gif/start.gif"
							alt="Start"
							width={24}
							height={24}
							unoptimized
						/>
						Check Eligibility
					</span>
				</Link>
			</div>
		</div>
	);
};
export default Hero;
